import { FunctionComponent } from "react";
import { resolveStaticPath, UnresolvedStaticPath } from "../../../lib/types/static-path";

type ListItemProps = {
  icon?: UnresolvedStaticPath;
  last?: boolean;
};

const ListItem: FunctionComponent<ListItemProps> = ({
  icon,
  last,
  children,
}) => {
  return (
    <li className={`flex items-center ${last ? null : "mb-6"} component-list-item`}>
      {icon ? (
        <img
          src={!icon ? "/image-2.jpg" : resolveStaticPath(icon)}
          className="mr-3 list-item-bullet"
        />
      ) : null}
      <p>{children}</p>
    </li>
  );
};

export default ListItem;
